import React from 'react';

import { FaArrowRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

import { StyledAboutCtaSection } from './styles';
import { GradientButton } from '../../../components/molecules/gradient-button';
import { Heading7, Paragraph2 } from '../../../theme';
import { bemClassName } from '../../../utils/bem';

const b = bemClassName('about-cta-section');

const AboutCtaSection = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/onboarding');
  };

  return (
    <StyledAboutCtaSection>
      <div className={b()}>
        <div className={b('inner')}>
          <Heading7>Ready to start your wellness journey?</Heading7>
          <Paragraph2>Join thousands who have transformed their health with Active Shape.</Paragraph2>
          <GradientButton onClick={handleGetStarted}>
            <span>Get Started</span>
            <FaArrowRight />
          </GradientButton>
        </div>
      </div>
    </StyledAboutCtaSection>
  );
};

export default AboutCtaSection;
